import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useQuestionFlagPost = () => {
  const createQuestionFlagPostRequest = useCallback((payload) => {
    const { activityId, message, questionId } = payload;

    const body = { message };

    const requestUrl = `${MONOLITH_ORIGIN}/api/v3/quiz/${activityId}/question/${questionId}/flag/`;

    return new Request(requestUrl, {
      method: "POST",
      body: JSON.stringify(body),
      headers: { "Content-Type": "application/json" },
    });
  }, []);

  return useRestMutation(createQuestionFlagPostRequest);
};

export default useQuestionFlagPost;
